import Service, { service } from '@ember/service';

export default class BillingPaymentCoordinatorService extends Service {
  @service currentPractice;
  @service billingModals;
  @service paymentInstrumentModals;

  constructor() {
    super(...arguments);

    this.showPayment = this.showPayment.bind(this);
    this.hidePayment = this.hidePayment.bind(this);
  }

  get paymentModalsService() {
    return this.currentPractice.get('featureStripeAchPayments')
      ? this.paymentInstrumentModals
      : this.billingModals;
  }

  showPayment(invoice = null) {
    this.paymentModalsService.showPayment(invoice);
  }

  hidePayment() {
    this.paymentModalsService.hidePayment();
  }
}
